import { GrowthBook } from '@growthbook/growthbook'
import { Tenants } from './environments'

export async function getCurrentTenant(growthBook?: GrowthBook | null) {
  // still relying on the feature flag for now
  return growthBook?.isOn('forvia-etl') ? Tenants.FORVIA : Tenants.DEFAULT
}
